import clsx from 'clsx'
import { FC } from 'react'

import classes from './index.module.scss'

interface Props {
  className?: string
  id: string
  shouldHaveMarginTop?: boolean
}

export const FieldError: FC<Props> = ({
  children,
  className = '',
  id,
  shouldHaveMarginTop = true
}) => (
  <span
    aria-live="polite"
    className={clsx(classes.root, className, { 'mt-1': shouldHaveMarginTop })}
    id={id}
  >
    {children}
  </span>
)
